const clientToken = import.meta.env.VITE_PAYMENTS_CLIENT_TOKEN;

export function PaymentTestModeBanner() {
  if (!clientToken) {
    return (
      <div className="w-full border-b border-destructive/40 bg-destructive/15 px-4 py-2 text-center text-xs text-destructive-foreground">
        Production checkout is not configured. Complete payments go-live to accept real payments.
      </div>
    );
  }
  if (typeof clientToken === "string" && clientToken.startsWith("pk_test_")) {
    return (
      <div className="w-full border-b border-amber-500/40 bg-amber-500/10 px-4 py-1.5 text-center text-xs text-amber-200">
        Test mode — checkout uses Stripe test cards (e.g. 4242 4242 4242 4242). No real charges.
      </div>
    );
  }
  return null;
}
